// Custom Turbo confirm method that shows a styled DaisyUI modal
// instead of the browser's native confirm() dialog.

const DESTRUCTIVE_PATTERNS = [
  { pattern: /\bdelete\b/i, label: "Delete" },
  { pattern: /\bremove\b/i, label: "Remove" },
  { pattern: /\brevoke\b/i, label: "Revoke" },
]

const ACTION_PATTERNS = [
  { pattern: /\bmove\b/i, label: "Move" },
  { pattern: /\bdismiss\b/i, label: "Dismiss" },
]

function classifyMessage(message) {
  for (const { pattern, label } of DESTRUCTIVE_PATTERNS) {
    if (pattern.test(message)) {
      return { destructive: true, label }
    }
  }
  for (const { pattern, label } of ACTION_PATTERNS) {
    if (pattern.test(message)) {
      return { destructive: false, label }
    }
  }
  return { destructive: true, label: "Confirm" }
}

export function showConfirmModal(message) {
  const dialog = document.getElementById("turbo-confirm-modal")
  const messageEl = document.getElementById("turbo-confirm-message")
  const acceptBtn = document.getElementById("turbo-confirm-accept")
  const cancelBtn = document.getElementById("turbo-confirm-cancel")
  const titleEl = document.getElementById("turbo-confirm-title")

  const { destructive, label } = classifyMessage(message)

  messageEl.textContent = message
  titleEl.textContent = "Are you sure?"
  acceptBtn.textContent = label
  acceptBtn.className = destructive
    ? "pt-btn pt-btn--danger pt-btn--sm"
    : "pt-btn pt-btn--sm"

  dialog.showModal()

  return new Promise((resolve) => {
    function cleanup() {
      acceptBtn.removeEventListener("click", onAccept)
      cancelBtn.removeEventListener("click", onCancel)
      dialog.removeEventListener("close", onClose)
    }

    function onAccept() {
      cleanup()
      dialog.close()
      resolve(true)
    }

    function onCancel() {
      cleanup()
      dialog.close()
      resolve(false)
    }

    // Handles Escape key and backdrop click (via the form method="dialog")
    function onClose() {
      cleanup()
      resolve(false)
    }

    acceptBtn.addEventListener("click", onAccept, { once: true })
    cancelBtn.addEventListener("click", onCancel, { once: true })
    dialog.addEventListener("close", onClose, { once: true })
  })
}
